// Astra · el idioma de la página, sacado de la dirección.
//
// Petición del servidor `PETICION_TRADUCCIONES_WEB.md` (04.11.26) y propuesta
// `PROPUESTA_TRADUCCIONES_WEB.md` en `astra-fm/temp`, aprobada por Pablo.
//
// 🔴 **El idioma va en el prefijo de la dirección**: `/en/…`, `/ca/…`, `/fr/…`,
// y el español sin prefijo. Es lo que necesitan los buscadores para indexar cada
// idioma por separado.
//
// 🔴 **El prefijo es la base del historial, no una ruta.** El router se crea con
// `createWebHistory("/en/")` y las rutas no cambian: `route.path` sigue siendo
// `/radar` y los `RouterLink` salen ya como `/en/radar`. Por eso cambiar de
// idioma **recarga la página** (`location.assign`): la base no se cambia en
// caliente.
//
// ⚠️ Las direcciones se quedan en español también con prefijo
// (`/fr/actualidad/<slug>`). Los PHP de Open Graph, el sitemap y el 301 de nginx
// no tienen que aprender traducciones.

export const IDIOMAS = ["es", "en", "ca", "fr"];

// El de referencia: va sin prefijo y es el que manda si una traducción falta.
export const IDIOMA_BASE = "es";

const CON_PREFIJO = IDIOMAS.filter((i) => i !== IDIOMA_BASE);
const PREFIJO = new RegExp(`^/(${CON_PREFIJO.join("|")})(?=/|$)`);

/** El idioma de una dirección: `/en/radar` → `en`, `/radar` → `es`. */
export function idiomaDe(pathname = "") {
  const m = String(pathname).match(PREFIJO);
  return m ? m[1] : IDIOMA_BASE;
}

/** La dirección sin el prefijo de idioma: `/en/radar` → `/radar`. */
export function sinIdioma(pathname = "") {
  return String(pathname).replace(PREFIJO, "") || "/";
}

/** La misma dirección en otro idioma: `('/radar', 'fr')` → `/fr/radar`. */
export function enIdioma(ruta, idioma) {
  const limpia = sinIdioma(ruta);
  if (idioma === IDIOMA_BASE) return limpia;
  return limpia === "/" ? `/${idioma}/` : `/${idioma}${limpia}`;
}

// El idioma de esta carga. No cambia mientras la página esté abierta.
export const IDIOMA =
  typeof window === "undefined" ? IDIOMA_BASE : idiomaDe(window.location.pathname);

/** La base del historial para `createWebHistory`: `/` o `/en/`. */
export const BASE_HISTORIAL = IDIOMA === IDIOMA_BASE ? "/" : `/${IDIOMA}/`;
